import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';

import { CampanhaSelectComponent } from './campanha-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CampanhaSelectComponent
    ],
    exports: [
        CampanhaSelectComponent
    ]
})
export class CampanhaSelectModule { }
